export default __webpack_public_path__ + "assets/images/6c4af96f9f7415dabe600c31832a7133.png";